import { faSnowflake } from "@fortawesome/free-regular-svg-icons"
import { faBahai, faBed, faBook, faBusinessTime, faCrutch, faDice, faDiceFive, faDiceFour, faDiceOne, faDiceSix, faDiceThree, faDiceTwo, faDisease, faDungeon, faEye, faHandcuffs, faHandFist, faHandshake, faHeadSideVirus, faMagnifyingGlass, faMoneyBill1Wave, faPaw, faPersonRunning, faSkullCrossbones, faUserInjured, IconDefinition } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { animations, cleanAnimations, scene } from "../ThreeTestFC"
import TWEEN, { Easing } from "@tweenjs/tween.js"
import * as THREE from "three";
import { Character, CharacterStat } from "../../../types"

export const getConditionIcon = (name: string): React.ReactNode => {
    // if (name === "detained") {
    //     return <FontAwesomeIcon icon={faSkullCrossbones} />
    // }
    if (name === "amnesia") {
        return <span className="color-red"><FontAwesomeIcon icon={faHeadSideVirus} /></span>
    }
    if (name === "detained") {
        return <span className="color-red"><FontAwesomeIcon icon={faHandcuffs} /></span>
    }
    if (name === "debt") {
        return <span className="color-red"><FontAwesomeIcon icon={faMoneyBill1Wave} /></span>
    }
    if (name === "leg_injury") {
        return <span className="color-red"><FontAwesomeIcon icon={faCrutch} /></span>
    }
    if (name === "back_injury") {
        return <span className="color-red"><FontAwesomeIcon icon={faUserInjured} /></span>
    }
    if (name === "delayed") {
        return <span className="color-red"><FontAwesomeIcon icon={faBusinessTime} /></span>
    }
    if (name === "hallucinations") {
        return <span className="color-red"><FontAwesomeIcon icon={faHeadSideVirus} /></span>
    }
    if (name === "paranoia") {
        return <span className="color-red"><FontAwesomeIcon icon={faHeadSideVirus} /></span>
    }
    if (name === "poisoned") {
        return <span className="color-red"><FontAwesomeIcon icon={faSkullCrossbones} /></span>
    }
    if (name === "hypothermia") {
        return <span className="color-red"><FontAwesomeIcon icon={faSnowflake} /></span>
    }
    if (name === "infection") {
        return <span className="color-red"><FontAwesomeIcon icon={faDisease} /></span>
    }
    if (name === "hunted") {
        return <span className="color-red"><FontAwesomeIcon icon={faPaw} /></span>
    }
    if (name === "lost_in_time_and_space") {
        return <span className="color-red"><FontAwesomeIcon icon={faBahai} /></span>
    }
    if (name === "blessed") {
        return <span className=""><FontAwesomeIcon icon={faDice} /></span>
    }
    if (name === "cursed") {
        return <span className="color-red"><FontAwesomeIcon icon={faDice} /></span>
    }
    // Impairments / Improvements
    if (name.split("_")[0] === "impair") {
        const stat = name.split("_")[1]
        if (stat === "inf") {
            return (
            <span className="color-red">
                <FontAwesomeIcon icon={faHandshake} className="me-1" />
            </span>)
        }
        if (stat === "lore") {
            return (
            <span className="color-red">
                <FontAwesomeIcon icon={faBook} className="me-1" />
            </span>)
        }
        if (stat === "obs") {
            return (
            <span className="color-red">
                <FontAwesomeIcon icon={faEye} className="me-1" />
            </span>)
        }
        if (stat === "str") {
            return (
            <span className="color-red">
                <FontAwesomeIcon icon={faHandFist} className="me-1" />
            </span>)
        }
        if (stat === "will") {
            return (
            <span className="color-red">
                <FontAwesomeIcon icon={faHeadSideVirus} className="me-1" />
            </span>)
        }
    }
    if (name.split("_")[0] === "improve") {
        const stat = name.split("_")[1]
        if (stat === "inf") {
            return (
            <span className="">
                <FontAwesomeIcon icon={faHandshake} className="me-1" />
            </span>)
        }
        if (stat === "lore") {
            return (
            <span className="">
                <FontAwesomeIcon icon={faBook} className="me-1" />
            </span>)
        }
        if (stat === "obs") {
            return (
            <span className="">
                <FontAwesomeIcon icon={faEye} className="me-1" />
            </span>)
        }
        if (stat === "str") {
            return (
            <span className="">
                <FontAwesomeIcon icon={faHandFist} className="me-1" />
            </span>)
        }
        if (stat === "will") {
            return (
            <span className="">
                <FontAwesomeIcon icon={faHeadSideVirus} className="me-1" />
            </span>)
        }
    }

    return <span className="color-red"><FontAwesomeIcon icon={faUserInjured} /></span>
}

export const getActionIcon = (name: string): React.ReactNode => {
    // if (name === "detained") {
    //     return <FontAwesomeIcon icon={faSkullCrossbones} />
    // }
    if (name === "rest") {
        return <FontAwesomeIcon icon={faBed} />
    }
    if (name === "otherworld") {
        return <FontAwesomeIcon icon={faDungeon} />
    }
    if (name === "clue") {
        return <FontAwesomeIcon icon={faMagnifyingGlass} />
    }

    return <FontAwesomeIcon icon={faPersonRunning} />
}

export const getConditionColor = (cName: string): string => {
    if (cName.split("_")[0] === "improve") {
        return "#d4c6ac"
    }
    if (cName === "blessed") {
        return "#d4c6ac"
    }
    return "#E53935"
}

export const animateHorizontal = (itm: any, amount: number, speed: number) => {
    if (scene.getObjectById(itm.id) === undefined) { return }

    const newAni = new TWEEN.Tween(itm.position).to({ x: itm.position.x-amount, y: itm.position.y, z: itm.position.z }, speed)
    .easing(Easing.Quadratic.InOut)
    .delay(Math.random()*150)
    .start()
    .onComplete(() => {
        cleanAnimations()
        const newAni = new TWEEN.Tween(itm.position).to({ x: itm.position.x+amount, y: itm.position.y, z: itm.position.z }, speed)
            .easing(Easing.Quadratic.InOut)
            .delay(Math.random()*150)
            .start()
            .onComplete(() => {
                animateHorizontal(itm, amount, speed)
                cleanAnimations()
            }
        )
        animations.push({id: itm.userData.id, ani: newAni})
    })

    animations.push({id: itm.userData.id, ani: newAni})

}

export const animateVertical = (itm: THREE.Group | THREE.Mesh, amount: number, speed: number) => {
    if (scene.getObjectById(itm.id) === undefined) { return }
    animations.push({
        id: itm.userData.id,
        ani: new TWEEN.Tween(itm.position).to({ x: itm.position, y: itm.position.y, z: itm.position.z-amount }, speed)
        .easing(Easing.Quadratic.InOut)
        .delay(Math.random()*150)
        .start()
        .onComplete(() => {
            cleanAnimations()
            animations.push({
                id: itm.userData.id,
                ani: new TWEEN.Tween(itm.position).to({ x: itm.position.x, y: itm.position.y, z: itm.position.z+amount }, speed)
                .easing(Easing.Quadratic.InOut)
                .delay(Math.random()*150)
                .start()
                .onComplete(() => {
                    animateVertical(itm, amount, speed)
                    cleanAnimations()
                })
            })
        })
    })
}

export const processDialogueMessage = (m: string): React.ReactNode => {
    return <span>{m}</span>
}

export const renderDiceRoll = (roll: number[]): React.ReactNode => {
    const renderDie = (d: number): React.ReactNode => {
        switch (d) {
            case 1:
                return <FontAwesomeIcon className="me-1" icon={faDiceOne} style={{opacity: .5}} />
            case 2:
                return <FontAwesomeIcon className="me-1" icon={faDiceTwo} style={{opacity: .5}} />
            case 3:
                return <FontAwesomeIcon className="me-1" icon={faDiceThree} style={{opacity: .5}} />
            case 4:
                return <FontAwesomeIcon className="me-1" icon={faDiceFour} style={{opacity: .5}} />
            case 5:
                return <FontAwesomeIcon className="me-1" icon={faDiceFive} />
            case 6:
                return <FontAwesomeIcon className="me-1" icon={faDiceSix} />
            default:
                break;
        }
        return <></>
    }

    return <>{roll.map(d => renderDie(d))}</>
}

export const getDialogueSubtitle = (d: Character["dialogueStatus"] | undefined): string | undefined => {
    if (d?.dialogueStyle === "mythos") {
        return "Mythos Event"
    }
    if (d?.dialogueStyle === "otherworld") {
        return "Other World Encounter"
    }
    if (d?.dialogueStyle === "mystery") {
        return "Mystery"
    }
}

export const renderWithIcons = (text: string): React.ReactNode[] => {
    const iconMap: Record<string, IconDefinition> = {
      "⚀": faDiceOne,
      "⚁": faDiceTwo,
      "⚂": faDiceThree,
      "⚃": faDiceFour,
      "⚄": faDiceFive,
      "⚅": faDiceSix,
    };
    const regex = new RegExp(Object.keys(iconMap).join('|'), 'g');
    const parts = text.split(regex);

    let matches = text.match(regex) || [];
    let output: React.ReactNode[] = [];

    const opacity = (i: IconDefinition): number => {
        if (i === faDiceFive || i === faDiceSix) {
            return 1
        }
        return 0.5
    }

    parts.forEach((part, i) => {
        output.push(part);
        if (matches[i]) {
            const icon = iconMap[matches[i]];
            output.push(<FontAwesomeIcon key={i} icon={icon} className="me-1" opacity={opacity(icon)} />);
        }
    });

    return output;
};

export const strToCharacterStat = (s: string): CharacterStat => {
    switch (s) {
        case "inf": return "inf"
        case "lore": return "lore"
        case "obs": return "obs"
        case "str": return "str"
        case "will": return "will"
        default: return "inf"
    }
}